<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTab.value"
    height="100%"
    @tab-click="tabClick"
    class="banzufenbao"
  >
    <template slot="btn">
      <FormItems :form="formRight" />
    </template>
    <template>
      <div class="box">
        <div class="form-box" v-if="currentTab.value === 'BanzufenbaoBg'">
          <FormItems :form="form" />
          <el-button type="primary" size="mini" @click="handleBgCalculate"
            >包干计算</el-button
          >
        </div>

        <LeftRightBox
          height="100%"
          :leftWidthDefault="300"
          :style="{ marginBottom: '10px' }"
        >
          <template slot="left">
            <SimpleTable
              :showIndex="false"
              ref="BanzufenbaoLeft"
              table-code="BanzufenbaoLeft"
              :menus="['查询', '批量修改']"
              :columns="currentTab.columnsLeft"
              :data="tableData.left"
              :loading="loading.left"
              :bottomFrozenRowCount="1"
              @row-select="onRowSelect"
            />
          </template>
          <template slot="right">
            <SimpleTable
              ref="BanzufenbaoRight"
              table-code="BanzufenbaoRight"
              :showIndex="false"
              :menus="['查询', '批量修改']"
              :columns="currentTab.columnsRight"
              :data="tableData.right"
              :loading="loading.right"
              :bottomFrozenRowCount="1"
              @modify-data-change="onModifyDataRight"
            />
          </template>
        </LeftRightBox>
      </div>
    </template>
  </TabBtn>
</template>

<script>
import TabBtn from '@/components/TabBtn/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import FormItems from '@/components/FormItems/index.vue'
import {
  sortRecords,
  addCbFn,
  aggregationSUM,
  aggregationAmount,
  initCalculation
} from '@/utils/index'

export default {
  name: 'Banzufenbao',
  components: { TabBtn, SimpleTable, LeftRightBox, FormItems },
  inject: ['detailsVm'],
  props: {
    importRecordId: {
      type: String,
      default: ''
    },
    summaryData: {
      type: Object,
      default: () => {}
    },
    getSummaryData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      form: [],
      // 页面数据
      tabs: [
        {
          label: '包干',
          value: 'BanzufenbaoBg',
          columnsLeft: [{ field: 'name', title: '施工班组', tree: true }],
          columnsRight: [
            { field: 'code', title: '编码', aggregation: aggregationSUM },
            { field: 'projectName', title: '项目名称' },
            { field: 'projectDesc', title: '项目特征' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '工程量' },
            { field: 'rate', title: '定额单价' },
            {
              field: 'amount',
              title: '定额金额',
              aggregation: aggregationAmount
            },
            { field: 'percentage', title: '占比' },
            {
              field: 'bgRate',
              title: '包干金额',
              aggregation: aggregationAmount
            },
            { field: 'bgAmount', title: '包干单价' }
          ],
          urlLeft: '/project-unit-budget/bg-bill/construction-group-tree',
          urlRight: '/project-unit-budget/bg-bill'
        },
        {
          label: '包活',
          value: 'BanzufenbaoBh',
          columnsLeft: [{ field: 'name', title: '施工班组', tree: true }],
          columnsRight: [
            { field: 'code', title: '编码', aggregation: aggregationSUM },
            { field: 'projectName', title: '项目名称' },
            { field: 'projectDesc', title: '项目特征' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '工程量' },
            {
              field: 'rate',
              title: '单价',
              fieldType: 'number',
              canEdit: true,
              canModify: true
            },
            {
              field: 'bhAmount',
              title: '包活金额',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              ),
              aggregation: aggregationAmount
            }
          ],
          urlLeft: '/project-unit-budget/bh-bill/construction-group-tree',
          urlRight: '/project-unit-budget/bh-bill'
        }
      ],
      currentTab: {},
      loading: {
        left: false,
        right: false
      },
      tableData: {
        left: [],
        right: []
      }
    }
  },
  computed: {
    formRight() {
      return [
        {
          label: '班组分包',
          value: this.summaryData.constructionGroupAmount,
          disabled: true
        }
      ]
    }
  },
  watch: {
    importRecordId() {
      this.getTableDataLeft()
      this.updateForm()
    },
    summaryData() {
      this.updateForm()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.tabClick(this.tabs[0])
      this.updateForm()
    },

    updateForm() {
      console.log(this.summaryData)
      if (this.currentTab.value === 'BanzufenbaoBg') {
        this.form = [
          {
            label: '单项工程',
            value: this.summaryData.unitProjectName,
            disabled: true
          },
          {
            label: '建筑规模',
            value: this.summaryData.constructionScale,
            disabled: true
          },
          { label: '包干单价', value: this.summaryData.bgRate, type: 'number' },
          {
            label: '包干金额',
            value: this.summaryData.bgAmount,
            disabled: true
          }
        ]
      } else {
        this.form = []
      }
    },

    tabClick(tab) {
      this.currentTab = tab

      this.getTableDataLeft()
      this.updateForm()
    },

    async getTableDataLeft() {
      this.tableData.left = []
      this.tableData.right = []
      this.loading.left = true
      const res = await this.$service.get(this.currentTab.urlLeft + '/list', {
        importRecordId: this.importRecordId
      })
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.BanzufenbaoLeft.initialized()
    },

    async getTableDataRight(obj) {
      this.tableData.right = []
      this.loading.right = true
      const res = await this.$service.get(this.currentTab.urlRight + '/list', {
        importRecordId: this.importRecordId,
        constructionGroupId: obj.id
      })
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
    },
    onRowSelect(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataRight(obj)
    },

    async onModifyDataRight(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        this.currentTab.urlRight + '/batch',
        getModifyData,
        cleanModifyData
      )

      this.getSummaryData()
    },

    async handleBgCalculate() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/bg-bill/calculate-bg',
        {
          importRecordId: this.importRecordId,
          bgRate: this.form[2].value
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.$message.success('包干计算成功')
        this.getTableDataLeft()
      }
    }
  }
}
</script>

<style scoped lang="less">
.banzufenbao {
  width: 100%;
  .box {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
  .form-box {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    gap: 10px;
  }
}
</style>
